import proxy from 'httpClient/requests';

export function getDeals() {
  return proxy({
    httpMethod: 'GET',
    timeout: 60,
    version: 1,
    apiMethod: 'hot_deals',
  });
}
